export default __webpack_public_path__ + "static/media/OpenSans-SemiBold.e2426461.woff2";